import { Configuration } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: 'd1260a3c-5c5e-40cd-84aa-323b2e957b00',
    authority:
      'https://login.microsoftonline.com/2898792b-c644-4207-bb78-a08f555def6c/',

    // redirect URI where the User gets redirected to by the Identity Provider after successful login
    redirectUri: `${window.location.origin}/overview`,
    // redirect URI where the User gets redirected to by the Identity Provider after successful logout
    postLogoutRedirectUri: `${window.location.origin}/overview`,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      logLevel: 1, // Error level logging
    }
  }
};
